import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosConfig';

// Асинхронное действие для получения последнего завершённого урока
export const fetchLastCompletedLesson = createAsyncThunk(
    'user/fetchLastCompletedLesson',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post('/last-completed-lesson');
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

// Асинхронное действие для получения текущего пользователя
export const fetchCurrentUser = createAsyncThunk(
    'user/fetchCurrentUser',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get('/auth/me');
            return response.data.user;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

const initialState = {
    userId: null,
    telegramId: null,
    username: '',
    role: '',
    accountType: null, // 'telegram', 'web', 'linked'
    isAccepted: false,
    isNew: false,
    lastCompletedModule: 1,
    lastCompletedLessonId: 0,
    loading: false,
    error: null
};

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUserData: (state, action) => {
            return { ...state, ...action.payload };
        },
        updateLastCompletedLesson: (state, action) => {
            const { lastCompletedModule, lastCompletedLessonId } = action.payload;
            state.lastCompletedModule = lastCompletedModule;
            state.lastCompletedLessonId = lastCompletedLessonId;
        },
        clearUserData: () => {
            localStorage.removeItem('authToken');
            return initialState;
        }
    },
    extraReducers: (builder) => {
        builder
            // Обработка fetchLastCompletedLesson
            .addCase(fetchLastCompletedLesson.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchLastCompletedLesson.fulfilled, (state, action) => {
                state.loading = false;
                state.lastCompletedModule = action.payload.lastCompletedModule;
                state.lastCompletedLessonId = action.payload.lastCompletedLessonId;
            })
            .addCase(fetchLastCompletedLesson.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Не удалось получить данные о завершённых уроках';
            })
            // Обработка fetchCurrentUser
            .addCase(fetchCurrentUser.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCurrentUser.fulfilled, (state, action) => {
                state.loading = false;
                const user = action.payload;
                state.userId = user._id;
                state.telegramId = user.telegramID || null;
                state.username = user.username || '';
                state.accountType = user.accountType;
                state.isAccepted = user.isAccepted;
                state.isNew = user.isNew || false;
                state.role = user.role || '';
            })
            .addCase(fetchCurrentUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Не удалось получить данные пользователя';
            });
    }
});

export const { setUserData, updateLastCompletedLesson, clearUserData } = userSlice.actions;
export default userSlice.reducer; 